/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraPlanAri } from '@atlassian/ari/jira/plan';
import parameters from './__generated__/AsyncPlanActionMenuContentQuery.graphql';
import type {
	AsyncPlanActionMenuEntrypointProps,
	AsyncPlanActionMenuQueries,
} from './AsyncPlanActionMenu.entrypoint.types.tsx';

type AsyncPlanActionMenuComponent = EntryPointComponent<
	AsyncPlanActionMenuQueries,
	{},
	AsyncPlanActionMenuEntrypointProps,
	{}
>;

export const asyncPlanActionMenu: EntryPoint<
	AsyncPlanActionMenuComponent,
	AsyncPlanActionMenuEntrypointProps
> = createEntryPoint({
	root: JSResourceForInteraction<AsyncPlanActionMenuComponent>(
		/* webpackChunkName: "async-plan-action-menu" */ './AsyncPlanActionMenuContent.tsx',
	),
	getPreloadProps: (params: AsyncPlanActionMenuEntrypointProps) => {
		if (!fg('plan_settings_sidebar_migrate_to_relay')) {
			return {};
		}
		const planAri = JiraPlanAri.create({
			siteId: params.cloudId,
			activationId: params.activationId,
			planId: String(params.planId),
		}).toString();

		return {
			queries: {
				invitePermissionRef: {
					parameters,
					variables: { planAri },
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
